export default "__VITE_ASSET__3fdb0ac2__"